import { useMutation } from "@shared/lib/hooks";
import { IVideoCompliance } from "@shared/lib/types/drafting";
import { BriefService } from "../../services/brief.service";

export default function useGenerateVideoCompliance() {
  const {
    mutate: generateCompliance,
    isLoading: isGeneratingCompliance,
    isSuccess: isGeneratingComplianceSuccess,
    error: generatingComplianceError,
    variables: generatedComplianceParams,
  } = useMutation({
    mutationFn: (data: IVideoCompliance) =>
      BriefService.generateVideoCompliance(data),
    options: {
      skipInvalidation: true,
    },
  });

  return {
    generateCompliance,
    isGeneratingCompliance,
    isGeneratingComplianceSuccess,
    generatingComplianceError,
    generatedComplianceParams,
  };
}
